<template>
  <div class="Vouchers">
    <div class="Input">
      <input v-model="voucher" :placeholder="t('placeholder')" @keydown.enter="addVoucher" />
      <div class="Apply" @click="addVoucher">{{ t('apply') }}</div>
    </div>

    <ul class="Codes">
      <li v-for="(voucher, index) in codes" :key="voucher.code + index">
        {{ t('code', { code: voucher.code }) }}
        <span class="Amount">{{ amount(voucher.amount, voucher.type) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { ADD_VOUCHER } from "@/store/modules/shop/types";
import shopMixin from "@/mixins/shop";

export default {
  name: 'Vouchers',
  mixins: [shopMixin],
  data() {
    return {
      voucher: null,
      codes: []
    }
  },
  methods: {
    t(key, params) {
      return this.$t(`cart.voucher.${key}`, params)
    },
    async addVoucher() {
      await this.$store.dispatch(ADD_VOUCHER, this.voucher)
    },
    amount(amount, type) {

      switch (type) {
        case 'percentage':
          // calculate discount
          const discountPrice = (this.subTotal * amount / 100).toString()
          // formatting
          const partsPercentage = discountPrice.split('.')
          if (partsPercentage.length == 2) {
            let amount = parseFloat(`${partsPercentage[0]}.${partsPercentage[1]}`).toFixed(2).padEnd(2, '0')
            return `-${amount}€`
          }
          else return `-${discountPrice}.${'0'.padEnd(2, '0')}€`

        case 'fixed_amount':
          const partsFixed = amount.split('.')
          return `-${partsFixed[0]}.${partsFixed[1].padEnd(2, '0')}€`
          
        default:
          return null
      }
    },
    initCodes() {
      if (!this.checkout) {
        this.codes = []
        return
      }

      this.codes = this.checkout.discountApplications.map(code => {

        let obj = {
          code: code.code
        }

        if (code.value.type.name === 'PricingValue') {
          if ('percentage' in code.value) {
            obj.type = 'percentage'
            obj.amount = code.value.percentage
          } else {
            obj.type = 'fixed_amount'
            obj.amount = code.value.amount
          }
        }

        return obj
      })
    }
  },
  mounted() {
    this.initCodes()
  },
  watch: {
    checkout() {
      this.initCodes()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.Vouchers {
  .Input {
    border: 3px solid $primary;
    margin: 3px;

    input {
      border: none;
      outline-width: 0;
      height: 40px;
      padding-left: 10px;
      padding-right: 10px;
      box-sizing: border-box;
    }

    .Apply {
      cursor: pointer;
      user-select: none;
      background-color: $primary;
      display: inline-block;
      color: white;
      padding: 15px 20px;
      text-transform: uppercase;
      font-size: 12px;
    }

    @media (max-width: 350px) {
      .Apply {
        display: block;
      }
    }
  }

  .Codes {
    list-style: none;
    padding: 0;
    text-align: right;

    li {
      margin-bottom: 10px;

      .Amount {
        font-style: italic;
      }
    }
  }
}
</style>
